import { Inline, Stack } from "PFComponents/containers";
import { ExperienceCommonProps } from "PFComponents/experience_level/experience_level.types";
import { IconSizeTable } from "PFComponents/icon/icon.utils";
import { Typography } from "PFComponents/typography";
import { useGetColor } from "PFCore/hooks/use_get_color";
import { Experience } from "PFTypes";
import { useTranslation } from "react-i18next";

import { RatingDots } from "../../rating_dots";

type RequiredExperienceTooltipContentProps = {
  requiredExperience: Experience;
} & ExperienceCommonProps;

export const RequiredExperienceTooltipContent = ({
  requiredExperience,
  experienceLevels,
  experienceLabelMap
}: RequiredExperienceTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "skillRatings" });

  const getColor = useGetColor();

  return (
    <Stack alignItems="center">
      <Typography tag="p" variant="labelRegular">
        {t("required")}
      </Typography>
      <Inline gap="spacingSm" alignItems="center">
        <RatingDots
          shape="rect"
          experience={requiredExperience}
          color={getColor("paletteWhite0")}
          colorSecondary={getColor("paletteBlue2")}
          size={IconSizeTable.xxs}
          experienceLevels={experienceLevels}
        />
        <Typography variant="labelBold">{experienceLabelMap[requiredExperience]}</Typography>
      </Inline>
    </Stack>
  );
};
